import React from 'react';
import PropTypes from 'prop-types';
import NextHead from 'next/head';

import { buildProductOffers } from './scriptMarkupProductData';
import { serializeJsonLd } from './serializeJsonLd';

// schema.org/Product JSON-LD for the product detail page. Built as an object and
// serialized with JSON.stringify so values (name/description from content files) can
// safely contain quotes or newlines without producing invalid JSON.

const ScriptMarkupProduct = (props) => {
  const offers = buildProductOffers(props);

  // A Product without offers/review/aggregateRating is error-level invalid for
  // Google (e.g. a product that is no longer sold), so emit nothing at all.
  if (!offers) {
    return null;
  }

  const data = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: props.name,
    image: props.images,
    description: props.description,
    sku: props.id,
    brand: { '@type': 'Brand', name: props.brand },
    offers,
  };

  const json = serializeJsonLd(data);

  return (
    <NextHead>
      <script
        key="ScriptMarkupProduct"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: json }}
      />
    </NextHead>
  );
};

ScriptMarkupProduct.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
  prices: PropTypes.arrayOf(PropTypes.number),
  currency: PropTypes.string,
  brand: PropTypes.string,
  host: PropTypes.string.isRequired,
};

export default ScriptMarkupProduct;
